export const layoutGraphic = {
  showlegend: false,
  xaxis: {
    tickformat: '%m-%d-%Y',
    zerolinecolor: '#E6E7E9',
  },
  font: {family: 'Proxima Nova Semibold', color: '#5D6E81'},
  hoverlabel: {
    font: {family: 'Proxima Nova Semibold'},
  },
};

export const valuesKeyMetricsStrength = {
  armStrengthLbs: {
    yAxisLabel: 'Lbs',
    values: ['totalStrength', 'internalRotation', 'externalRotation', 'scaption', 'grip'],
  },
  armStrength: {
    yAxisLabel: '% BW',
    values: ['totalStrength', 'internalRotation', 'externalRotation', 'scaption', 'grip'],
  },
  shoulderBalance: {
    yAxisLabel: 'ER:IR',
    values: ['erIrRatio'],
  },
  strengthVelocityRatio: {
    yAxisLabel: 'SVR',
    values: ['svr'],
  },
  armRecovery: {
    yAxisLabel: 'Lbs',
    values: ['totalStrength', 'internalRotation', 'externalRotation', 'scaption', 'grip'],
  },
  strengthVelocityRatioVelocity: {
    yAxisLabel: 'MPH',
    values: ['velocity'],
  },
};

export const schemaGraphicStrength = {
  armStrengthLbs: {
    checked: true,
    id: 'armStrengthLbs',
    title: 'STRENGTH LBS',
    metrics: {},
  },
  armStrength: {
    checked: false,
    id: 'armStrength',
    title: 'STRENGTH %BW',
    metrics: {},
  },
  shoulderBalance: {
    checked: false,
    id: 'shoulderBalance',
    title: 'SHOULDER BALANCE',
    metrics: {},
  },
  strengthVelocityRatio: {
    checked: false,
    title: 'SVR',
    id: 'strengthVelocityRatio',
    metrics: {},
  },
  armRecovery: {
    checked: false,
    id: 'armRecovery',
    title: 'RECOVERY',
    metrics: {},
  },
  strengthVelocityRatioVelocity: {
    checked: false,
    title: 'VELOCITY',
    id: 'strengthVelocityRatioVelocity',
    metrics: {},
  },
};

export const valuesKeyMetricsFatigue = {
  strength: {
    yAxisLabel: '% Fresh',
    values: ['freshTotalRatio', 'freshIRRatio', 'freshERRatio', 'freshScaptionRatio', 'freshGripRatio'],
  },
};

export const schemaGraphicFatigue = {
  strength: {
    checked: true,
    id: 'fatigue',
    title: 'FATIGUE',
    metrics: {},
  },
};
